module.exports = __webpack_public_path__ + "static/click_heatmap_login-371d8fc95b72943db60bf4a5d3ef174b.jpg";